import React from "react";
import styles from "../../views/ReportView/ReportView.module.css";

const Glossary = () => {
  const predefinedValues = [
    {
      concepto: "Abm de Documento",
      definicion:
        "Esta sección permite realizar operaciones de Alta, Baja o Modificación (ABM) en el documento de la persona. Aquí puedes gestionar y actualizar la información relacionada con la documentación de la persona.",
    },
    {
      concepto: "Información Económica",
      definicion:
        "En esta sección se muestran las variables economicas de la Persona Humana.",
    },
    {
      concepto: "Pagos y cobros",
      definicion:
        "En esta sección se registran y detallan todas las transacciones financieras relacionadas con la persona. Cada entrada incluye información sobre si se trata de un ingreso o un egreso, una descripción de la transacción, la fecha en que se creó y el monto correspondiente. Esto proporciona una visión completa de la situación económica de la persona y su historial financiero.",
    },
    {
      concepto: "Información Empleador",
      definicion:
        "En esta sección se encuentra las variables relacionadas con el empleador del asociado.",
    },
    {
      concepto: "Relación con la Mutual",
      definicion:
        "En esta sección existe la relación que el registro tiene con la mutual, el cual puede ser ",
    },
    {
      concepto: "Información Pep",
      definicion:
        "En esta sección se encuentra la variable PEP, es decir si la persona es políticamente expuesta.",
    },
    {
      concepto: "Información Terrorismo",
      definicion:
        "En esta sección se enuentran las variables relacionadas a terrorismo, contactando las bases públicas.",
    },
    {
      concepto: "Matriz de Variables",
      definicion:
        "Esta matriz determina el riesgo que posee la persona en base a las políticas generadas por el organismo.",
    },
  ];

  return (
    <div className={styles.Glossary} id="glosario">
      <div className={styles.sectionTitle2}>
        <h2 className={styles.sectionTitleH2}>Glosario</h2>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Concepto</th>
            <th>Definición</th>
          </tr>
        </thead>
        <tbody>
          {predefinedValues.map((item, index) => (
            <tr key={index}>
              <td>{item.concepto}</td>
              <td>{item.definicion}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Glossary;
